import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "amount",
  class: "w-full"
}
const _hoisted_2 = { class: "stepper__title" }
const _hoisted_3 = { class: "stepper__subtitle" }
const _hoisted_4 = { class: "stepper__content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Entire holding", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "w-[150px] text-left" }, "Custom amount", -1)
const _hoisted_7 = { class: "flex items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_advanced_dropdown = _resolveComponent("advanced-dropdown")!
  const _component_nomad_button = _resolveComponent("nomad-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.subtitle), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["stepper__option", {
          'stepper__option--active': !_ctx.sendCustom,
        }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectFull && _ctx.selectFull(...args)))
      }, [
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(_ctx.formattedBalance) + " " + _toDisplayString(_ctx.selectedToken.symbol), 1)
      ], 2),
      _createVNode(_component_advanced_dropdown, { text: _ctx.dropdownText }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["stepper__option", {
            'stepper__option--active': _ctx.sendCustom,
          }]),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectCustom && _ctx.selectCustom(...args)))
          }, [
            _hoisted_6,
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _createVNode(_component_n_input, {
                type: "number",
                ref: "amount",
                value: _ctx.amt,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.amt) = $event)),
                placeholder: "0.0",
                size: "tiny",
                style: {"min-width":"100px","max-width":"300px"},
                class: "blank-input overflow-visible font-extra-light bg-transparent outline-none text-right"
              }, null, 8, ["value"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.selectedToken.symbol), 1)
            ], 512), [
              [_vShow, _ctx.sendCustom]
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    _createVNode(_component_nomad_button, {
      primary: "",
      class: "stepper__continue",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('next'))),
      disabled: !_ctx.valid
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Continue ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_nomad_button, {
      class: "w-full flex justify-center",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('back')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Back ")
      ]),
      _: 1
    })
  ]))
}